import { ZONE_LABELS, ZONE_NAMES, type ZoneModel } from '@painpal/core';

export const itemAt = (list: readonly string[], index: number): string => list[index] ?? '';

// Zone payloads carry no model name; LTHR and max HR have different zone counts.
export function hrModelFor(zoneCount: number): ZoneModel {
  return zoneCount === ZONE_NAMES.hr_max.length ? 'hr_max' : 'hr_lthr';
}

export function zoneLabels(model: ZoneModel): string[] {
  return ZONE_NAMES[model].map((name, i) => `${itemAt(ZONE_LABELS[model], i)} ${name.toUpperCase()}`);
}

export function boundRange(bounds: readonly number[], index: number, unit: string): string {
  const lower = bounds[index - 1];
  const upper = bounds[index];
  if (lower === undefined) return `< ${String(upper)} ${unit}`;
  if (upper === undefined) return `≥ ${lower} ${unit}`;
  return `${lower}–${upper - 1} ${unit}`;
}
